import "../styles/global.css";

function About() {
  return (
    <div className="about-container">
      <div className="about-content">
        <h1 className="about-title">Welcome to Shehab Engineering</h1>
        {/* <h2 className="about-subtitle">Industrial Machinery Manufacturing</h2> */}

        <p className="about-description">
          We are technical and commercial representatives of major multinational and international companies.
          These companies manufacture a wide range of products in the field of:
        </p>

        <ul className="about-list">
          <li>Pharmaceutical production machinery</li>
          <li>Pharmaceutical packaging materials</li>
          <li>Active Pharmaceutical Ingredients (API)</li>
          <li>Industrial Equipment</li>
          <li>Food Machinery</li>
        </ul>

        <p className="about-note">
          We pride ourselves in our principals’ high-quality products and unmatched after-sales service.
        </p>

        {/* Contact Information */}
        <div className="about-contact-container">
          <h2 className="about-contact-title">Contact Us</h2>
          <p className="about-contact"><strong>Phone:</strong> +(20) (2) 2274 0831</p>
          <p className="about-contact">
  <strong>Email:</strong> <a href="mailto:info@shehabcorp.com">info@shehabcorp.com</a></p>
        </div>

        {/* Google Maps Embed */}
        <div className="map-container">
          <iframe
            title="Company Location"
            width="100%"
            height="350"
            style={{ border: 0, borderRadius: "12px", filter: "brightness(0.9) contrast(1.2)" }}
            loading="lazy"
            allowFullScreen
            referrerPolicy="no-referrer-when-downgrade"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d863.4234306186934!2d31.341788!3d30.045643499999994!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14583e8813468e7d%3A0x929685531af1b6d9!2sShehab%20Engineering!5e0!3m2!1sen!2seg!4v1739351414648!5m2!1sen!2seg">
          </iframe>
        </div>
      </div>
    </div>
  );
}

export default About;
